import { LogoRocket } from '@localstack/ui';
import { Box, Button, Stack, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { useApiGetter, MembershipService } from '@localstack/services';
import { styled } from '@mui/styles';

import { useSignout } from '~/hooks/useSignout';
import { getSectionItemTextColor } from '~/layouts/components/Navbar/shared';

const MainBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
}));

const StyledTitleTypography = styled(Typography)(({ theme }) => ({
  marginLeft: '0.5em',
  color: getSectionItemTextColor(theme),
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textAlign: 'left',
  fontWeight: 500,
}));

const StyledStack = styled(Stack)(() => ({
  alignItems: 'center',
}));

export const NoNavbarHeader = (): ReactElement => {
  const { data: primaryMembership } = useApiGetter(MembershipService, 'getPrimaryMembership', []);
  const { handleSignOut } = useSignout();

  return (
    <MainBox>
      <StyledStack direction="row">
        <LogoRocket size="small" />
        <StyledTitleTypography>{primaryMembership?.org_name}</StyledTitleTypography>
      </StyledStack>
      <Button onClick={() => handleSignOut()}>Sign Out</Button>
    </MainBox>
  );
};
